import { cwslapi } from "../index";

// 获取新闻列表
export const getNewslistApi = (data) => { 
  return cwslapi({
    url: "/news/getNewslist",
    method: "post",
    data,
  });
};
// catId*   新闻分类id,0：全部,1:新闻 2：公告，3：攻略，4：活动

// page	  页码数

// types*	 home：首页，lists：列表页


// /news/getNewsDetail


// 获取新闻内页
export const getNewsDetailApi = (data) => { 
    return cwslapi({
      url: "/news/getNewsDetail",
      method: "post",
      data,
    });
  };